export enum QueryStatusEnum {
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}

export enum ErrorStatus {
  Unauthorized = 401,
  Forbidden = 403,
  GatewayTimeout = 504,
}

export enum IdParamsEnum {
  AccountId = 'accountId',
  UnitId = 'unitId',
  UserId = 'userId',
  ActionId = 'actionId',
  CompanyId = 'companyId',
}

export enum AccountStatus {
  Active = 'Active',
  Closed = 'Closed',
  Blocked = 'Blocked',
  AwaitingReview = 'Awaiting Review',
  Rejected = 'Rejected',
  Removed = 'Removed',
}
